export default __webpack_public_path__ + "static/media/shield.4ebd2e73.svg";